import { gql } from '@apollo/client';

export const WSAudioStorageQuery = gql`
  query RecordingUploadStatus($sessionId: String!) {
    recordingUploadStatus(sessionId: $sessionId) {
      sessionId
      provider
      canBeDeleted
    }
  }
`;

export const GetTranscriptsByEncounterID = gql`
  query GetTranscriptsByEncounterID($encounterId: ID!) {
    GetTranscriptsByEncounterID(encounterId: $encounterId) {
      id
      documentReferenceId
      encounterId
      patientId
      sessionId
      createdAt
      durationSeconds
      sizeBytes
      source
      originalFilename
    }
  }
`;

export const GetTranscriptsBySessionID = gql`
  query GetTranscriptsBySessionID($sessionId: ID!) {
    GetTranscriptsBySessionID(sessionId: $sessionId) {
      id
      documentReferenceId
      encounterId
      patientId
      sessionId
      transcript
      createdAt
      durationSeconds
      sizeBytes
      source
      originalFilename
    }
  }
`;

export const ManualAudioUploadStatusQuery = gql`
  query ManualAudioUploadStatus($sessionId: ID!) {
    manualAudioUploadStatus(sessionId: $sessionId) {
      sessionId
      source
      recordingStatus
      processingStatus
      startedAt
      completedAt
      updatedAt
      error {
        message
        code
      }
    }
  }
`;

// `forms` is an object keyed by form key, e.g. { 'medical-history': { ... } }.
export const AiDocumentStatusQuery = gql`
  query AiDocumentStatus($encounterId: ID!) {
    aiDocumentStatus(encounterId: $encounterId) {
      formKey
      ready
      storedAt
    }
  }
`;

export const GetAiGeneratedFormDataQuery = gql`
  query GetAiGeneratedFormData($encounterId: ID!, $formName: String!) {
    getAiGeneratedFormData(encounterId: $encounterId, formName: $formName) {
      encounterId
      formName
      sessionIds
      data
    }
  }
`;

export const GetEncounterRecordingEligibilityQuery = gql`
  query GetEncounterRecordingEligibility($encounterId: ID!) {
    GetEncounterRecordingEligibility(encounterId: $encounterId) {
      canStart
      reason
    }
  }
`;

export const GetEncounterSummaryQuery = gql`
  query GetEncounterSummary($sessionId: ID!) {
    encounterSummary(sessionId: $sessionId) {
      sessionId
      status
      summary
      errorMessage
      createdAt
    }
  }
`;
